import HttpClient from "@lib/http-client";

const checklistUrl = (orgCode, path = "") =>
  `/organization/${orgCode}/setup-checklist${path}`;

export default class SetupChecklistService extends HttpClient {
  getChecklist(orgCode) {
    return this.http.get(checklistUrl(orgCode));
  }

  // 201 on a new confirmation, 200 with the original row when one is already
  // live. Neither carries the re-evaluated checklist: refetch after writing.
  confirm(orgCode, key) {
    return this.http.post(checklistUrl(orgCode, "/attestations"), { key });
  }

  // 204 whether or not a confirmation existed.
  clear(orgCode, key) {
    return this.http.delete(
      checklistUrl(orgCode, `/attestations/${encodeURIComponent(key)}`)
    );
  }

  // 201 on a new or changed answer, 200 with the original row when the option
  // is already live.
  answer(orgCode, key, option) {
    return this.http.post(checklistUrl(orgCode, "/answers"), { key, option });
  }
}
